export default "__VITE_ASSET__BSYfTvZu__"